module.exports = __webpack_public_path__ + "media/images/lp_check-gray-e22bc9ed1ce09b7e53ceba569f18a025.webp";